export const ERRORS_VALUE_BLACKLIST = [
  'Loading chunk',
  'Loading CSS chunk',
  'Non-Error promise rejection captured with keys: isTrusted',
  'The operation is insecure.',
  "Unexpected token '<'",
];

export const ERRORS_LIB_BLACKLIST = ['@loadable/component'];
